import React from "react";

import { Button } from "shared/ui/Button";
import { CodeInput } from "shared/ui/CodeInput";
import { LabeledField } from "shared/ui/LabeledField";
import { NotificationSnackbar } from "shared/ui/NotificationSnackbar";
import { PhoneInput } from "shared/ui/PhoneInput";
import { TextInput } from "shared/ui/TextInput";

import { useSignInState } from "./hooks/useSignInState";
import { Card, Fields, MethodSwitch, Screen, Subtitle, Title } from "./styles";

export const SignIn = () => {
    const state = useSignInState();

    const isCodeStep = state.step === "code";

    return (
        <Screen>
            <Card>
                <Title>Вход в админку</Title>
                <Subtitle>
                    {isCodeStep
                        ? "Введите код из SMS"
                        : "Доступ только для сотрудников restify.one"}
                </Subtitle>

                <Fields>
                    <LabeledField label="Номер телефона" htmlFor="phoneNumber">
                        <PhoneInput
                            id="phoneNumber"
                            value={state.phoneNumber}
                            onChange={state.setPhoneNumber}
                            disabled={state.submitting || isCodeStep}
                            autoFocus
                            onSubmit={
                                state.method === "code"
                                    ? state.onRequestCode
                                    : state.onSubmitPassword
                            }
                        />
                    </LabeledField>

                    {isCodeStep && (
                        <LabeledField label="Код из SMS">
                            <CodeInput
                                value={state.code}
                                onChange={state.onChangeCode}
                                onComplete={state.onSubmitCode}
                                length={state.codeLength}
                                disabled={state.submitting}
                                autoFocus
                            />
                        </LabeledField>
                    )}

                    {state.method === "password" && (
                        <LabeledField label="Пароль" htmlFor="password">
                            <TextInput
                                id="password"
                                type="password"
                                value={state.password}
                                onChange={state.setPassword}
                                disabled={state.submitting}
                            />
                        </LabeledField>
                    )}

                    {state.method === "code" && !isCodeStep && (
                        <Button
                            fullWidth
                            onClick={state.onRequestCode}
                            disabled={!state.isPhoneComplete || state.submitting}
                        >
                            Получить код
                        </Button>
                    )}

                    {state.method === "password" && (
                        <Button
                            fullWidth
                            onClick={state.onSubmitPassword}
                            disabled={!state.canSubmitPassword || state.submitting}
                        >
                            Войти
                        </Button>
                    )}

                    {isCodeStep && (
                        <Button
                            fullWidth
                            variant="text"
                            color="neutral"
                            onClick={state.onBackToCredentials}
                            disabled={state.submitting}
                        >
                            Изменить номер
                        </Button>
                    )}
                </Fields>

                {!isCodeStep && (
                    <MethodSwitch
                        type="button"
                        onClick={() =>
                            state.onChangeMethod(state.method === "code" ? "password" : "code")
                        }
                        disabled={state.submitting}
                    >
                        {state.method === "code" ? "Войти по паролю" : "Войти по коду из SMS"}
                    </MethodSwitch>
                )}
            </Card>

            <NotificationSnackbar {...state.notify.snackbarProps} />
        </Screen>
    );
};
